var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56055 4.76953V9.32953C6.56317 9.83263 6.7642 10.3144 7.11995 10.6701C7.4757 11.0259 7.95745 11.2269 8.46055 11.2295H10.2305",
    stroke: "#8B909A",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68 13.3095H10.23V13.4995C10.23 14.0034 10.0298 14.4867 9.6735 14.843C9.31718 15.1994 8.83391 15.3995 8.33 15.3995H2.9C2.39609 15.3995 1.91282 15.1994 1.5565 14.843C1.20018 14.4867 1 14.0034 1 13.4995V6.66953C1 6.16562 1.20018 5.68235 1.5565 5.32603C1.91282 4.96971 2.39609 4.76953 2.9 4.76953H3.78V11.4095C3.78 11.9134 3.98018 12.3967 4.3365 12.753C4.69282 13.1094 5.17609 13.3095 5.68 13.3095Z",
    stroke: "#8B909A",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2293 11.2295H8.4593C7.9562 11.2268 7.47445 11.0258 7.1187 10.6701C6.76295 10.3143 6.56192 9.83255 6.5593 9.32945V2.68945H5.6793C5.17539 2.68945 4.69211 2.88963 4.33579 3.24595C3.97947 3.60227 3.7793 4.08554 3.7793 4.58945V11.4095C3.7793 11.9134 3.97947 12.3966 4.33579 12.753C4.69211 13.1093 5.17539 13.3095 5.6793 13.3095H10.2293",
    stroke: "#8B909A",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56055 2.68945V9.32945C6.56317 9.83255 6.7642 10.3143 7.11995 10.6701C7.4757 11.0258 7.95745 11.2268 8.46055 11.2295H10.2305",
    stroke: "#8B909A",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0205 11.2295V11.4095C13.0205 11.9134 12.8203 12.3967 12.464 12.753C12.1077 13.1093 11.6244 13.3095 11.1205 13.3095H10.2305",
    stroke: "#8B909A",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8005 2.49961V9.32961C15.8005 9.83352 15.6004 10.3168 15.2441 10.6731C14.8877 11.0294 14.4045 11.2296 13.9005 11.2296H8.46055C7.95745 11.227 7.4757 11.026 7.11995 10.6702C6.7642 10.3145 6.56317 9.83271 6.56055 9.32961V2.49961C6.56317 1.99651 6.7642 1.51476 7.11995 1.15901C7.4757 0.803258 7.95745 0.602237 8.46055 0.599609H13.9005C14.4045 0.599609 14.8877 0.799787 15.2441 1.15611C15.6004 1.51243 15.8005 1.9957 15.8005 2.49961Z",
    stroke: "#8B909A",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8694 8.35008H8.86938M13.6294 6.00008H8.88937M13.6094 3.58008L8.85938 3.63008",
    stroke: "#8B909A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchIcon);
export default __webpack_public_path__ + "static/media/BatchIcon.76ff1e6c9bca7dbeb4ffd079a0a41d15.svg";
export { ForwardRef as ReactComponent };